function Stars() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
    >
      <text
        id="_"
        data-name=""
        transform="translate(1 18)"
        fill="#daa520"
        fontSize="20"
        fontFamily="FontAwesome5Pro-Regular, 'Font Awesome \35  Pro'"
      >
        <tspan x="0" y="0">
          
        </tspan>
      </text>
    </svg>
  );
}

export default Stars;
